<script setup>
import { ref } from "vue";
import { CheckCircleIcon } from "@heroicons/vue/24/solid";
import { recoveryPassword } from "@/services/auth";

const email = ref("");
const errorMessage = ref("");
const successMessage = ref("");
const buttonText = ref("Restablecer Contraseña");

const handleSubmit = async () => {
  errorMessage.value = "";
  successMessage.value = "";

  if (!validateEmail(email.value)) {
    errorMessage.value = "Por favor, ingresa un correo electrónico válido.";
    return;
  }

  try {
    await recoveryPassword(email.value);
    buttonText.value = "Iniciar Sesión";
    successMessage.value = "Revisa tu correo para restablecer contraseña.";
  } catch (error) {
    errorMessage.value =
      "Hubo un problema al enviar la solicitud. Inténtalo de nuevo.";
    console.error(
      "Error en la solicitud de recuperación de contraseña:",
      error
    );
  }
};

const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
</script>
<template>
  <article class="global-container register">
    <div class="register-card">
      <div class="card-body">
        <h5 class="register-title" style="font-size: 18px">
          Golden Contactability
        </h5>
        <h6
          class="register-pre-title"
          style="margin-top: 2rem; font-size: 22px"
        >
          Restablecer Contraseña.
        </h6>

        <form @submit.prevent="handleSubmit">
          <div class="mb-3">
            <label for="password" class="form-label"
              >Ingresa el correo electrónico registrado.</label
            >
            <input
              type="email"
              class="form-control login-input"
              id="exampleInputEmail1"
              v-model="email"
            />
          </div>

          <div v-if="errorMessage" class="error-message text-danger">
            {{ errorMessage }}
          </div>
          <div
            v-if="successMessage"
            class="success-message text-success d-flex gap-2 fw-bold"
          >
            <CheckCircleIcon
              class="text-blue-500 d-flex justify-content-center"
              style="width: 25px; height: 25px"
            ></CheckCircleIcon>
            {{ successMessage }}
          </div>

          <div class="d-flex justify-content-center mt-4">
            <router-link to="/login">
              <button
                v-if="buttonText === 'Iniciar Sesión'"
                class="globals-border-button"
                style="width: 15rem"
              >
                Iniciar Sesión
              </button>
            </router-link>
            <button
              v-if="buttonText === 'Restablecer Contraseña'"
              type="submit"
              class="btn register-button px-4"
              style="width: 15rem"
            >
              {{ buttonText }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </article>
</template>
<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";
.error-message {
  text-align: center;
  color: $error2-color;
  margin: 5px 0;
}
.note-text {
  color: $six-color;
  font-size: 0.7em;
}
.input-in {
  border: none;
  width: 100%;
  &:focus,
  &:focus-within {
    outline: none;
    box-shadow: none;
  }
}
</style>
